<template>
  <fs-scrollable
    :class="{
      'fs-menu': true,
      'fs-menu--scrollable': isScrollable,
    }"
    @click="handleClick"
    @is-scrollable="(scrollable) => (isScrollable = scrollable)"
  >
    <div
      ref="root"
      :class="{
        'fs-menu__wrapper': true,
        'fs-menu__wrapper--scrollable': isScrollable,
      }"
    >
      <slot></slot>
    </div>
  </fs-scrollable>
</template>

<script setup lang="ts">
import FsScrollable from '@components/fs-scrollable.vue';
import { fsPopperClose } from '@components/poppers/fs-popper.vue';
import { inject, provide, ref, useTemplateRef } from 'vue';

defineOptions({ name: 'fs-menu' });

const { closeOnSelect = true } = defineProps<{ closeOnSelect?: boolean }>();

const isScrollable = ref(false);
const rootElement = useTemplateRef('root');

const parentCloseMenu = inject<(() => void) | undefined>('closeMenu', undefined);

provide('closeMenu', () => {
  fsPopperClose(rootElement.value);
  parentCloseMenu?.();
});

function handleClick() {
  if (closeOnSelect) {
    fsPopperClose(rootElement.value);
    parentCloseMenu?.();
  }
}
</script>

<style scoped lang="scss">
@import '@styles/variables';

.fs-menu {
  padding: 0.7rem 0;

  &--scrollable {
    padding-right: 0.8rem;
    margin-left: 0.8rem;
  }

  &__wrapper {
    padding: 0 0.8rem;

    &--scrollable {
      padding: 0;
    }

    & :deep(.fs-menu-group:first-child .fs-menu-group__title) {
      margin-top: 0;
    }

    & :deep(.fs-menu-item:not(:last-child)) {
      margin-bottom: 1px;
    }
  }
}
</style>
